import { Component, OnInit, ViewChild, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addbranch',
  templateUrl: './addbranch.component.html',
  styleUrls: ['./addbranch.component.css']
})
export class AddbranchComponent implements OnInit ,AfterViewInit {

  @ViewChildren('input')firstipcontrol;
  
  @ViewChild('documentbar', { static: false }) documentbar;
  
  formname: string = "Branch";
  trxtype: string = "BRANCH";
  
//Display
formmode:string="Add";

 //Mode Values
 isaddmode:boolean=false;
 iseditmode:boolean=false;
 isdeletemode:boolean=false;
 isviewmode:boolean=false;

 isloading: boolean = false;
   isprivilage: boolean = false;
   showProgress: boolean = false;   


 //Save Validation
 submitted:boolean;
 successfully:boolean;
 saveloading: boolean;

 //Edit Get Values
 companycheckColl:any=[];
 branchColl:any=[];
 branchBO:any={};
 branchid:number=0
 
 branchform=new FormGroup({
  branchid:new FormControl(0),        
  branchcode:new FormControl('',Validators.required),         
  branchname:new FormControl('',Validators.required),          
 });


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
    public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
      this.route.queryParams.subscribe(params => {
        if(params.id!==undefined){
          this.branchid = params.id
        }          
      });

      this.fnServiceChanges();
}

  
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
    try{
        this.isaddmode=true;
        this.branchform.reset();
        this.fnInitializeFormGroup(); 

        if(this.branchid>0){
          this.fngetBranch();
        }
       
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.branchid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}  
ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}
fnInitializeFormGroup(){
    this.branchform.setValue({
      branchid:0,    
      branchcode:'',
      branchname:'',              
    })
}





//Get 
fngetBranch() {
  if (this.showProgress) {
    return;
  }          
      var data = {
        'branchid':this.branchid,
        'companyid':this.loginService.fnGetCompanyId()          
      }
      this.appService.getBranch(data)
      .subscribe(
        (res)=>{                
          if(res.json().status===200){ 
            this.fnHideProgress();
 
            this.branchColl=res.json().result;
            var editdata = this.branchColl[0];        
            this.branchBO=editdata;
            this.fnEditMode(editdata);

            this.documentbar.trxtype = this.trxtype;
            this.documentbar.trxid = this.branchid;
            this.documentbar.formname = this.formname;
            this.documentbar.fnGetDocument();
            
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }
          
      },
      (err)=>{  
        this.fnHideProgress();
        
        this.toastr.error('Error', err);
      })
}




//Save Btn Click
fnSaveBtnClick(){
    try{
      if (this.saveloading) {
        return;        
    }                           
      this.submitted=true;
      this.successfully=false;
      //Validate
      if(this.branchform.valid){
          //Check
          this.saveloading = true;
 
          var data = {
                'branchid': this.branchid,       
                'branchcode':this.branchform.get('branchcode').value,            
                'branchname':this.branchform.get('branchname').value,            
                'companyid':this.loginService.fnGetCompanyId(),
                'createdby': this.loginService.fnGetModUserId(),  
               'modifiedby':this.loginService.fnGetModUserId(),                                                              
          }

        
          this.appService.fnCheckBranch(data).subscribe(
            (res)=>{
              if(res.json().status===200){  
                var _checkresult=res.json().result[0].checkfield;
              
                if(_checkresult==="done"){
                      if (this.branchform.get('branchid').value>0){
                        //Update 
                        this.fnSetBranch(data);
                      }
                      else{
                        //Insert 
                        this.fnInsertBranch(data);
                      }
                }
                else{        
                      if(_checkresult==="code"){
                        this.saveloading = false;

                        this.branchform.controls['branchcode'].setErrors({'notfound': true});
                      }
                }
              }
              else {
                this.saveloading = false;

                this.loginService.fnAPIError(res.json())
              }
          },
          (err)=>{
            this.saveloading = false;

              this.toastr.error('Error', err);           
          });
       }
    }catch(ex){
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
}

//Insert
fnInsertBranch(data){    
  
    this.appService.fnInsertBranch(data).subscribe(
      (res)=>{
        this.saveloading = false;

        if(res.json().status===200){  
          if(res.json().result!=""){
            this.toastr.success('', "The new Branch has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.branchname);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
    },
      (err)=>{
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

}

//Set
fnSetBranch(data){    

this.appService.fnSetBranch(data).subscribe(
  (res)=>{
    this.saveloading = false;

    if(res.json().status===200){  
          if(res.json().result!=""){
              this.toastr.success('', "The Branch has been updated successfully.");
              this.fnInsertActivityLog('EDIT',this.branchid,data.branchname);
              this.fnCloseForm();        
          } 
      }
    else {
      
      this.loginService.fnAPIError(res.json())
    }
  },
  (err)=>{
    this.saveloading = false;

    this.toastr.error('Error', err);
  });

}

//Close
fnCloseForm(){
try{
   this.router.navigate(['/Branch']);
}catch(ex){
    this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
  this.branchform.setValue({ 
    branchid :deptBO.branchid, 
    branchcode:deptBO.branchcode,
    branchname:deptBO.branchname 
  });

  this.formmode="Edit";
    
  this.iseditmode=true;
  this.isdeletemode=false;
  this.isviewmode=false;
}

fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
} 

private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}




}
